export const baseChipStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '1px 8px 1px 6px',
  borderRadius: '12px',
  border: '1px solid',
  verticalAlign: 'middle',
  lineHeight: 1.4,
  cursor: 'pointer',
  transition: 'background-color 120ms ease, border-color 120ms ease',
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
};

export const inertChipStyles = {
  ...baseChipStyles,
  cursor: 'default',
  borderColor: 'divider',
  color: 'text.secondary',
  backgroundColor: 'transparent',
};

export const tombstoneChipStyles = {
  ...baseChipStyles,
  borderColor: 'divider',
  color: 'text.disabled',
  backgroundColor: 'transparent',
  textDecoration: 'line-through',
  cursor: 'default',
};

export const labelStyles = {
  lineHeight: 1,
  color: 'inherit',
};

export const deltaBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 14,
  height: 14,
  borderRadius: '50%',
  backgroundColor: 'warning.main',
  color: 'warning.contrastText',
  // Intentionally below the smallest CDS scale step: a single-glyph badge inside a 14px circle —
  // the 12px minimum overflows the chip-height-bounded chrome.
  fontSize: 10,
  lineHeight: 1,
};

export const hoverContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  minWidth: 200,
};

export const hoverFieldRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 2,
};

export const hoverHintStyles = {
  marginTop: 0.5,
  width: 'fit-content',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
};
